import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { INITIATED_BY } from 'domains/customer-refund/constants'


const propTypes = {
  initiated_by: PropTypes.string
}

/**
 * Badge for Customer Refund Shipment initiated by.
 * @param {string} initiated_by selected initiated by
 */
const CustomerRefundShipmentInitiatedBy = ({ initiated_by }) => {

  const colorMap = {
    [INITIATED_BY.CUSTOMER] : 'primary',
    [INITIATED_BY.CS]       : 'info'
  }

  const color = colorMap[initiated_by] || 'default'

  return <StatusBadge color={ color } label={ initiated_by } />
}

CustomerRefundShipmentInitiatedBy.propTypes = propTypes

export default CustomerRefundShipmentInitiatedBy
